package com.essntl.features.message.ui.all_conversation

import com.essntl.core.utils.viewmodel.PaginationState
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.message.domain.model.WhapiChatModel
import com.essntl.features.supplier.domain.model.SupplierModel
import com.essntl.features.travelagent.domain.model.TravelAgentModel
import com.essntl.uikit.components.chat.conversation.ConversationFilterOptions
import com.essntl.uikit.components.chat.conversation.ConversationListUiState

data class AllConversationState(
    val getAllWhapiChats: PaginationState<WhapiChatModel> = PaginationState(),
    val getAllWhapiGroups: State<List<WhapiChatModel>> = State(),
    val getAllSupplier: State<List<SupplierModel>> = State(),
    val getAllTravelAgent: State<List<TravelAgentModel>> = State(),
    val getAllClient: State<List<ClientModel>> = State(),
    val selectedConversationId: String? = null,
    val filterOptions: ConversationFilterOptions = ConversationFilterOptions(),
) {
    val isLoading
        get() =
            getAllWhapiChats.isLoading

    val isFailure
        get() =
            getAllWhapiChats.isFailure

    private val chats get() = getAllWhapiChats.data.filter { it.type == WhapiChatModel.ChatType.Contact }

    private val groups get() = getAllWhapiGroups.data.orEmpty()

    val allConversations
        get() = (chats + groups).sortedWith(
            compareByDescending { it.lastMessage?.timestamp },
        )

    fun toUiState(chats: List<WhapiChatModel>): ConversationListUiState =
        ConversationListUiState(
            filterOptions = filterOptions,
            conversations = chats
                .map { chat ->
                    val client =
                        getAllClient.data.orEmpty().firstOrNull { it.telephone == chat.phoneNumber }
                            ?: ClientModel.empty.copy(telephone = chat.phoneNumber)
                    val contactUiState = client.toContactUiState
                    chat.toUiState(contact = contactUiState.copy(name = contactUiState.name ?: chat.name))
                },
        )
}
